// Home → Blog → Article breadcrumb for the article detail page.
// (Separate from mixins/jsonld/breadcrumbs.js which is catalog-oriented.)
import { safeJsonLd } from "@/utils/jsonldSafe";

export default {
  computed: {
    breadcrumbsBlogJsonldScript() {
      const a = this.article;
      if (!a) return null;

      const baseUrl = `https://${this.$config.website.domain}`;
      const url = `${baseUrl}${this.$route.path}`;

      const schema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: `${baseUrl}/`,
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: `${baseUrl}/blog`,
          },
          {
            "@type": "ListItem",
            position: 3,
            name: a.title,
            item: url,
          },
        ],
      };

      return {
        hid: "jsonld-breadcrumbs",
        type: "application/ld+json",
        innerHTML: safeJsonLd(schema),
      };
    },
  },
};
